import { initStep1 } from './step1'
import { initStep2 } from './step2'
import { initStep3 } from './step3'
import { initThankYouPage } from './thankYouPage'
import { _t } from '../base.js'
function addCartFooter() {
    const contentWrapper = document.getElementById('content-wrapper')

    if (contentWrapper) {
        const cartFooter = document.createElement('div')
        cartFooter.classList.add('cart-footer')
        cartFooter.innerHTML = /* HTML */ `
            <div class="cart-footer__top">
                <div class="container">
                    <ul>
                        <li>${_t('allAboutHelloCoco')}</li>
                        <li><a href="${_t('aboutUsLink')}">${_t('aboutUs')}</a></li>
                        <li><a href="${_t('reviewsLink')}">${_t('reviews')}</a></li>
                        <li><a href="${_t('contactUsLink')}">${_t('contactUs')}</a></li>
                    </ul>
                    <ul>
                        <li>${_t('contact')}</li>
                        <li><a href="mailto:${_t('cocoEmail')}">${_t('cocoEmail')}</a></li>
                        <li class="cart-footer__phone">+421 915 748 723</li>
                    </ul>
                    <ul>
                        <li>${_t('purchase')}</li>
                        <li><a href="${_t('termsAndConditionsLink')}">${_t('termsAndConditions')}</a></li>
                        <li><a href="${_t('privacyPolicyLink')}">${_t('privacyPolicy')}</a></li>
                    </ul>
                </div>
            </div>
            <div class="cart-footer__bottom">
                <div class="container">
                    <div class="cart-footer__copyright">©2019 - 2025 hello coco</div>
                    <div class="cart-footer__socials">
                        <a href="https://www.instagram.com/hellococo_skcz" target="_blank">
                            <img
                                src="/user/documents/upload/Ikony/instagram.svg"
                                alt="instagram"
                                loading="eager" />
                        </a>
                        <a href="https://www.facebook.com/hellococoskcz/" target="_blank">
                            <img
                                src="/user/documents/upload/Ikony/facebook.svg"
                                alt="facebook"
                                loading="eager" />
                        </a>
                        <a
                            href="https://www.tiktok.com/@hellococo.skcz?_t=ZN-8u19iuQfoMY&_r=1"
                            target="_blank">
                            <img src="/user/documents/upload/Ikony/tiktok.svg" alt="tiktok" loading="eager" />
                        </a>
                    </div>
                    <div class="cart-footer__able">
                        <img src="/user/documents/upload/Ikony/able-logo.svg" alt="able" loading="eager" />
                    </div>
                </div>
            </div>
        `

        contentWrapper.parentNode.insertBefore(cartFooter, contentWrapper.nextSibling)
    }
}

export function initCart() {
    initStep1()
    initStep2()
    initStep3()
    initThankYouPage()
    addCartFooter()
}
